export const statusColorsExcludingOther = ['#cd7700', '#1c73ff', '#d41100', '#6c49b8', '#bb6bd9', '#318483'];

export const statusColorOther = '#858589';

export const statusColorDefault = '#ffffff';
